module.exports = __webpack_public_path__ + "static/media/2.Pen Gun.b894f58b.jpg";